import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../react-query/constants";
import { toast } from "react-toastify";
import { toastOptions } from "../utils";
import { getLoginToken } from "../storage";

async function getSLA() {
  const data = await axiosInstance({
    url: "/sla",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createSLA = async (formData: any) => {
  const data = await axiosInstance({
    url: "/sla",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateSLA = async (formData: any) => {
  const data = await axiosInstance({
    url: `/sla/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteSLA = async (formData: any) => {
  const data = await axiosInstance({
    url: `/sla/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useSLA() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.sla],
    queryFn: () => getSLA(),
  });
  return data;
}

export function useCreateSLA() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createSLA(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.sla]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateSLA() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateSLA(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.sla]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteSLA() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteSLA(formData),
    onSuccess: (data) => {
      toast.success("SLA Deleted Successfully", toastOptions);
      queryClient.invalidateQueries([queryKeys.sla]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
